var map = {
	"./en-in": [
		"oRMd",
		2
	],
	"./en-in.json": [
		"oRMd",
		2
	],
	"./ex-in": [
		"5cf/",
		1
	],
	"./ex-in.json": [
		"5cf/",
		1
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "lgBR";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/assets/lang lazy ^\.\/.*$
// module id = lgBR
// module chunks = 13